const SCRIPT_URL = "https://checkout.razorpay.com/v1/checkout.js";

export function loadRazorpayScript() {
  if (typeof window === "undefined") {
    return Promise.resolve(false);
  }

  if (window.Razorpay) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${SCRIPT_URL}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(Boolean(window.Razorpay)));
      existing.addEventListener("error", () => resolve(false));
      return;
    }

    const script = document.createElement("script");
    script.src = SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve(Boolean(window.Razorpay));
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export function openRazorpayCheckout({
  keyId,
  orderId,
  amount,
  currency,
  planName,
  userName,
  userEmail,
  userPhone,
  onSuccess,
  onDismiss,
  onFailure,
}) {
  if (!window.Razorpay) {
    throw new Error("Razorpay failed to load.");
  }

  const options = {
    key: keyId,
    amount,
    currency,
    name: "Karanki Matrimony",
    description: planName,
    order_id: orderId,
    prefill: {
      name: userName || "",
      email: userEmail || "",
      contact: userPhone || "",
    },
    theme: { color: "#c90243" },
    handler: (response) => {
      onSuccess(response);
    },
    modal: {
      ondismiss: onDismiss,
      // Confirm before closing so accidental taps don't lose the payment
      confirm_close: true,
      escape: true,
    },
    retry: { enabled: true, max_count: 1 },
  };

  const checkout = new window.Razorpay(options);

  // Handle payment failures (declined card, wrong OTP, insufficient funds, etc.)
  checkout.on("payment.failed", (response) => {
    if (typeof onFailure === "function") {
      const err = response?.error || {};
      onFailure({
        code: err.code || "",
        description: err.description || "Payment failed. Please try again.",
        reason: err.reason || "",
        step: err.step || "",
        paymentId: err.metadata?.payment_id || "",
        orderId: err.metadata?.order_id || "",
      });
    }
  });

  checkout.open();
}
